import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeHyphen',
  standalone: false,
})
export class RemoveHyphenPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return value;
    }
    return value.replace(/ *- +/g, '');
  }
}
